import { combineReducers } from '@reduxjs/toolkit';
import JobTicketReducer from './reducer';
const reducer = combineReducers({
  JobTicketReducer
});

export default reducer;